import {
  Grid2 as Grid,
  Box,
  Stepper,
  Step,
  StepButton,
  Button,
  Stack
} from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { ConditionalGrid } from "@shared/components";
import { FluxFormProps } from "./types";
import { useAgreementForm } from "./controller";
import {
  RegisterStep,
  ModuleStep,
  WhiteLabelStep,
  IntegrationsStep,
  LegalStep
} from "./Steps";

export function FluxForm({ onSubmit, isSubmitting }: FluxFormProps) {
  const translate = useTranslate();
  const {
    steps,
    activeStep,
    handleStep,
    handleSubmit,
    handleBack,
    isLastStep
  } = useAgreementForm();

  const renderStepContent = (stepIndex: number) => {
    switch(stepIndex) {
      case 0: return <RegisterStep />;
      case 1: return <ModuleStep />;
      case 2: return <WhiteLabelStep />;
      case 3: return <IntegrationsStep />;
      case 4: return <LegalStep />;
      default: return null;
    }
  };

  return (
    <Box component="form" sx={{ display: "flex", flexDirection: "column" }}>
      <Grid container spacing={6}>
        <Grid size={{ xs: 12 }}>
          <Stepper nonLinear activeStep={activeStep}>
            {steps.map((label, index) => (
              <Step key={label}>
                <StepButton onClick={handleStep(index)}>
                  {label}
                </StepButton>
              </Step>
            ))}
          </Stepper>
        </Grid>

        <Grid size={{ xs: 12 }}>
          {steps.map((_, index) => (
            <ConditionalGrid key={index} isVisible={activeStep === index}>
              {renderStepContent(index)}
            </ConditionalGrid>
          ))}
        </Grid>

        <Grid size={{ xs: 12 }}>
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button
              disabled={activeStep === 0 || isSubmitting}
              onClick={handleBack}
              variant="outlined"
            >
              {translate("buttons.back")}
            </Button>

            <Button
              variant="contained"
              onClick={() => handleSubmit(onSubmit)}
              color="primary"
              loading={isSubmitting}
            >
              {isLastStep
                ? translate("buttons.finish")
                : translate("buttons.next")}
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}
